import React from 'react';

import { Form } from 'common/components';

const RolePermissionsSectionRow = ({
  handleClickPermissionRow,
  handleCheckPermission,
  permission,
  t,
  values,
  isChecked = false,
}) => {
  const checkIsCustomFieldOrTranslate = (permissionToCheck) => {
    let newPermissionName = null;
    if (permissionToCheck.includes('acl.custom_field.', 0)) {
      // Example: acl.custom_field.nameOfCustom.get.609ee14cf4151a7af26c9c75
      // acl.custom_field. length = 17
      // 609ee14cf4151a7af26c9c75 length = 24
      // 24 for the ObjectId.
      // 1 for the dot to remove.
      const charsToRemoveAtTheEnd = 24 + 1;
      // acl.custom_field.nameOfCustom.get.609ee14cf4151a7af26c9c75

      const removedAcl = permissionToCheck.substring(17, permissionToCheck.length);
      // nameOfCustom.get.609ee14cf4151a7af26c9c75

      const namePlusAction = removedAcl.substring(0, removedAcl.length - charsToRemoveAtTheEnd);
      // nameOfCustom.get

      const indexOfDot = namePlusAction.lastIndexOf('.'); // check the las dot index.
      const action = namePlusAction.substring(indexOfDot + 1, namePlusAction.length);
      // nameOfCustom

      const name = namePlusAction.substring(0, indexOfDot);
      // get

      const actions = {
        // get: (name) => "Mostrar el campo ( " + name + " )",
        // add: (name) => "Agregar a grupo el campo ( " + name + " )",
        // toggle: (name) => "Activar/Desactivar el campo ( " + name + " )"
        get: (name) => name + ' - Mostrar el campo',
        add: (name) => name + ' - Agregar a grupo el campo',
        toggle: (name) => name + ' - Activar/Desactivar el campo',
      };

      newPermissionName = actions[action](name);
      // newPermissionName = action + " " + name;
    }
    return newPermissionName || t(permissionToCheck);
  };
  return (
    <tr onClick={(e) => handleClickPermissionRow(e, permission)} style={{ cursor: 'pointer' }}>
      <td>
        <Form.Checkbox
          className="icheckbox_flat-blue"
          value={permission}
          onChange={handleCheckPermission}
          checked={isChecked}
        />
      </td>
      <td>{checkIsCustomFieldOrTranslate(permission)}</td>
      <td>{permission}</td>
    </tr>
  );
};

export default RolePermissionsSectionRow;



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/components/RolePermissionsSectionRow.js